/**
 * @file Mixin to allow changing class to update styles to support
 *  different font family
 *  Classes are specified in global.scss.
 *
 */

import { Component, Getter, Vue } from '@@/bits/vue'

const fontIdClassMap = {
  1: 'sans-font-family',
  2: 'serif-font-family',
  3: 'cursive-font-family',
  4: 'mono-font-family',
}

@Component({})
class GlobalStylesMixin extends Vue {
  @Getter fontId!: 1 | 2 | 3 | 4

  get globalStyleClasses(): string[] {
    return [fontIdClassMap[this.fontId]]
  }
}

export default GlobalStylesMixin
